import { Applications } from "@biggeo/bg-server-lib/studio";
export const datascapeCookies = {
    uuid: "uuid",
    jwt: "2pgon6u94ltg1j1a",
};
export const studioCookies = {
    uuid: "uuid",
    jwt: "2pgon6u94ltg1j09",
};
export const datalabCookies = {
    uuid: "uuid",
    jwt: "2pgon6u94ltg1j6m",
};
export const marketplaceCookies = {
    uuid: "uuid",
    jwt: "2pgon6u94ltg1j1z",
};
export const getCookies = (app) => {
    switch (app) {
        case Applications.datalab:
            return datalabCookies;
        case Applications.datascape:
            return datascapeCookies;
        case Applications.marketplace:
            return marketplaceCookies;
        default:
            return studioCookies;
    }
};
//# sourceMappingURL=utils.js.map